import call from "@/api/calls";
import LogRocket from "logrocket"

const initialState = () => ({
  chapters: null,
  profiles: null,
  places: null,
  chapIds: {},
  profIds: {},
  placIds: {},
});

const state = initialState();

const mutations = {
  SET_CHAPTERS(state, data) {
    state.chapters = data;
  },
  ADD_CHAPTERS(state, data) {
    state.chapters.push(data);
    state.chapIds[data.id] = true;
  },
  INIT_CHAPTERS(state) {
    state.chapters || (state.chapters = []);
  },

  SET_PROFILES(state, data) {
    state.profiles = data;
  },
  ADD_PROFILES(state, data) {
    state.profiles.push(data);
    state.profIds[data.id] = true;
  },
  INIT_PROFILES(state) {
    state.profiles || (state.profiles = []);
  },

  SET_PLACES(state, data) {
    state.places = data;
  },
  ADD_PLACES(state, data) {
    state.places.push(data);
    state.placIds[data.id] = true;
  },
  INIT_PLACES(state) {
    state.places || (state.places = []);
  },

  RESET_IDS(state) {
    state.chapIds = {};
    state.profIds = {};
    state.placIds = {};
  }
}

const getters = {
  getChapters(state) {
    return state.chapters;
  },
  getProfiles(state) {
    return state.profiles;
  },
  getPlaces(state) {
    return state.places;
  },
}

const actions = {
  searchChapters({ state, commit }, { query, options }) {
    return call.chapter.search(query, options)
    .then(chapters => {
      commit("INIT_CHAPTERS");
      for (let chapter of chapters) {
        if (!state.chapIds[chapter.id])
          commit("ADD_CHAPTERS", chapter);
      }
      return chapters;
    })
    .catch(error => LogRocket.error(error));
  },
  searchProfiles({ state, commit }, { query, options }) {
    return call.profile.search(query, options)
    .then(profiles => {
      // console.log("inside searchProfiles.", query, options.pagination);
      commit("INIT_PROFILES");
      for (let profile of profiles) {
        if (!state.profIds[profile.id])
          commit("ADD_PROFILES", profile);
      }
      return profiles;
    })
    .catch(error => LogRocket.error(error));
  },
  searchPlaces({ commit }, { query, options }) {
    // console.log("inside searchPlaces.", query, options.pagination);
    return call.group.search(query, options)
    .then(places => {
      commit("INIT_PLACES");
      for (let place of places) {
        if (!state.placIds[place.id])
          commit("ADD_PLACES", place);
      }
      return places;
    })
    .catch(error => LogRocket.error(error));
  },
  clearSearch({ commit }) {
    // console.log("clearing search...");
    commit("SET_CHAPTERS", null);
    commit("SET_PROFILES", null);
    commit("SET_PLACES", null);
    commit("RESET_IDS");
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
